module.exports = __webpack_public_path__ + "img/Award.0d1efa71.jpg";